export default __webpack_public_path__ + "static/media/VIPL_Fiscal_22.47759996.pdf";